import { FC } from 'react'

import styled from 'styled-components'

import { ScheduleSteps } from 'src/Components/PrimaryScheduleTabs'
import { useScheduleGenres } from 'src/Pages/Artist/SpotifySchedulePage/helpers/useScheduleGenres'
import { capitalizeWords } from 'src/Helpers/layoutHelpers'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ProperGenreOrLanguage } from 'src/Types/tracks'
import { ModalType } from 'src/Types/ui'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { AddParameterButton } from 'src/Components/Buttons/AddParameterButton'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  margin-bottom: 6px;
`
const SubTitle = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const GenresList = styled(SubTitle)`
  font-weight: 400;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  gap: 1px;
`
const ContainerWithError = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

interface ScheduleGenresProps {
  genres: ProperGenreOrLanguage[]
}

export const SpotifyScheduleGenres: FC<ScheduleGenresProps> = ({ genres }) => {
  const { setSearch } = useCustomSearchParams()
  const { handleGenrePopupOpenedEvent } = useGenresAndLanguagesAnalytics()

  const handleClick = (): void => {
    const query = {
      step: ScheduleSteps.SETTINGS,
      modal: ModalType.Genres,
    }
    setSearch(query)

    handleGenrePopupOpenedEvent({
      platformName: CampaignPlatformTypeEnum.SPOTIFY,
    })
  }

  useScheduleGenres()

  if (!genres.length) {
    return (
      <AddParameterButton onClick={handleClick}>
        <span>Add target genres</span>
      </AddParameterButton>
    )
  }

  const genresString = genres
    .map((genre) => capitalizeWords(genre.name || ''))
    .join(', ')

  return (
    <Container>
      <ContainerWithError>
        <Wrapper>
          <SubTitle>Track genres</SubTitle>
          <GenresList translate='no'>{genresString}</GenresList>
        </Wrapper>
        <PrimaryDottedButton onClick={handleClick}>Edit</PrimaryDottedButton>
      </ContainerWithError>
    </Container>
  )
}
